import { render, staticRenderFns } from "./ClinicDetails.vue?vue&type=template&id=50c84fdb&scoped=true"
import script from "./ClinicDetails.vue?vue&type=script&lang=js"
export * from "./ClinicDetails.vue?vue&type=script&lang=js"
import style0 from "./ClinicDetails.vue?vue&type=style&index=0&id=50c84fdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c84fdb",
  null
  
)

export default component.exports